<div class="route">
    <div class="route__line-wrapper">
        <div class="route__line-wrapper__icon first-step">
            <span>1</span>
        </div>
        <div class="route__line-wrapper__line">
    
        </div>
        <div class="route__line-wrapper__icon icon-start">
            <img src="/assets/img/play-svgrepo-com.svg" alt="">
        </div>
        <div class="route__line-wrapper__line">
    
        </div>
        <div class="route__line-wrapper__icon icon-flag">
            <img src="/assets/img/flag-2-svgrepo-com.svg" alt="">
        </div>
    </div>

    <div class="route__locations-wrapper">
        <div class="route__locations-wrapper__column left">
            <span class="street">
                <ng-container *ngIf="(routeData.D.S?.Br || routeData.D.S?.St) else noGPSStart">
                    {{routeData.D.S?.Cr}}, {{ routeData.D.S?.Br }}, ul. {{ routeData.D.S?.St }}
                </ng-container>
                <ng-template #noGPSStart>
                    {{ 'reports.noGPS' | translate }}
                </ng-template>
            </span>
            <span class="date">{{ routeData.St | date : 'HH:mm:ss dd.MM.yyyy' }}</span>
        </div>
        <div class="route__locations-wrapper__column right">
            <span class="street">
                <ng-container *ngIf="(routeData.D.E?.Br ||  routeData.D.E?.St) else noGPSEnd">
                    {{routeData.D.E?.Cr}}, {{ routeData.D.E?.Br }}, ul. {{ routeData.D.E?.St }}</ng-container>
                <ng-template #noGPSEnd>
                    {{ 'reports.noGPS' | translate }}
                </ng-template>
            </span>
            <span class="date">{{ routeData.En | date : 'HH:mm:ss dd.MM.yyyy' }}</span>
        </div>
    </div>
</div>
